import React, { useContext, useState, useEffect } from "react";
import {
  AppBar,
  Box,
  Button,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Typography,
  Tooltip,
  useMediaQuery,
  useTheme,
  Collapse,
  MenuItem,
  Menu,
  Avatar,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
// import HomeIcon from "@mui/icons-material/Home";
// import MiscellaneousServicesIcon from "@mui/icons-material/MiscellaneousServices";
// import WorkIcon from '@mui/icons-material/Work';
// import ContactMailIcon from "@mui/icons-material/ContactMail";
import LoginIcon from "@mui/icons-material/Login";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import LogoutIcon from "@mui/icons-material/Logout";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import {
  WbSunnyOutlined,
  SettingsBrightness,
  BedtimeOutlined,
} from "@mui/icons-material";
import RouterLink from "src/hooks/RouterLink";
import { ThemeContext } from "src/theme/index";
import api from "src/Api";

import { useSelector } from "react-redux";
export default function Header() {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery("(max-width: 1085px)");
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isTransparent, setIsTransparent] = useState(true);
  const { themeMode, changeThemeMode } = useContext(ThemeContext);

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const auth = useSelector((state) => state.auth);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        // Check if user is logged in
        const token = localStorage.getItem("token");
        if (token) {
          const response = await api.get("users/get");
          setIsLoggedIn(true);
          setCurrentUser(response.data);
        }
      } catch (err) {
        console.error(err);
      }
    };

    checkAuth();
  }, []);

  // For theme menu
  const [themeMenuAnchorEl, setThemeMenuAnchorEl] = useState(null);
  const themeMenuOpen = Boolean(themeMenuAnchorEl);

  // For mobile theme menu collapse
  const [mobileThemeMenuOpen, setMobileThemeMenuOpen] = useState(false);

  // For user menu
  const [userMenuAnchorEl, setUserMenuAnchorEl] = useState(null);
  const userMenuOpen = Boolean(userMenuAnchorEl);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsTransparent(false);
      } else {
        setIsTransparent(true);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleDrawerOpen = () => {
    setDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  const handleThemeMenuClick = (event) => {
    setThemeMenuAnchorEl(event.currentTarget);
  };

  const handleThemeMenuClose = () => {
    setThemeMenuAnchorEl(null);
  };

  const handleUserMenuClick = (event) => {
    setUserMenuAnchorEl(event.currentTarget);
  };

  const handleUserMenuClose = () => {
    setUserMenuAnchorEl(null);
  };

  const handleMobileThemeMenuToggle = () => {
    setMobileThemeMenuOpen(!mobileThemeMenuOpen);
  };

  const handleThemeChange = (mode) => {
    changeThemeMode(mode);
    handleThemeMenuClose();
    setMobileThemeMenuOpen(false);
  };

  const handleLogout = async () => {
    try {
      localStorage.removeItem("token");
      setIsLoggedIn(false);
      setCurrentUser(null);
      handleUserMenuClose();
      // Redirect to home page if needed
      // window.location.href = '/';
    } catch (err) {
      console.error(err);
    }
  };

  const navLinks = [
    {
      label: "Accueil",
      href: "/",
      // icon: <HomeIcon fontSize="medium" />
    },
    // {
    //   label: "Nos services",
    //   href: "/services",
    //   icon: <MiscellaneousServicesIcon fontSize="medium" />,
    // },
    {
      label: "Nos offres d'emploi",
      href: "/jobs",
      //icon: <WorkIcon fontSize="medium" />,
    },
    {
      label: "Contact",
      href: "/contact",
      //icon: <ContactMailIcon fontSize="medium" />,
    },
  ];

  const getThemeIcon = () => {
    switch (themeMode) {
      case "light":
        return <WbSunnyOutlined />;
      case "dark":
        return <BedtimeOutlined />;
      default:
        return <SettingsBrightness />;
    }
  };

  const getThemeLabel = () => {
    switch (themeMode) {
      case "light":
        return "Thème clair";
      case "dark":
        return "Thème sombre";
      default:
        return "Thème système";
    }
  };

  // Get user's initials for avatar
  const getUserInitials = () => {
    if (!currentUser || !currentUser.fname || !currentUser.name) return "U";

    const firstInitial = currentUser.fname[0];
    const lastInitial = currentUser.name[0];

    return `${firstInitial}${lastInitial}`.toUpperCase();
  };

  return (
    <AppBar
      position="fixed"
      color={isTransparent ? "transparent" : "default"}
      elevation={isTransparent ? 0 : 1}
      sx={{
        borderBottom: `1px solid ${theme.palette.divider}`,
        borderRadius: 0,
        margin: 0,
        height: isMobile ? 76 : 76,
        display: "flex",
        justifyContent: "center",
        backgroundColor: isTransparent
          ? "transparent"
          : theme.palette.background.paper,
        boxShadow: isTransparent ? "none" : "0px 2px 4px rgba(0, 0, 0, 0.1)",
        transition:
          "background-color 0.3s, box-shadow 0.3s, border-bottom 0.3s",
      }}
    >
      <Toolbar
        sx={{
          minHeight: "inherit",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box sx={{ flexGrow: 1 }}>
          <Typography variant="h6" color="inherit" noWrap>
            <Box component={RouterLink} href="/">
              <Box
                component="img"
                src={
                  theme.palette.mode === "dark"
                    ? "/statics/logo_white.png"
                    : "/statics/logo.png"
                }
                sx={{
                  width: 62,
                  height: 62,
                  cursor: "pointer",
                  transition: "transform 0.3s",
                  "&:hover": { transform: "scale(1.1)" },
                }}
              />
            </Box>
          </Typography>
        </Box>

        {!isMobile && (
          <Box
            sx={{
              display: "flex",
              gap: 8,
              justifyContent: "center",
              flexGrow: 1,
            }}
          >
            {navLinks.map((link) => (
              <Button
                key={link.href}
                component={RouterLink}
                onClick={() => navigate(link.href)}
                href={link.href}
                sx={{
                  color: theme.palette.mode === "dark" ? "white" : "#797979",
                  fontWeight: "bold",
                  fontSize: "0.9rem",
                  fontFamily: "'Inter', serif",
                  letterSpacing: "-1.1%",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    color: theme.palette.primary.main,
                    transform: "scale(1.05)",
                    backgroundColor: isTransparent
                      ? "rgba(255, 255, 255, 0.1)"
                      : "rgba(189, 189, 189, 0.1)",
                  },
                }}
              >
                {link.icon}
                {link.label}
              </Button>
            ))}
          </Box>
        )}

        {!isMobile && (
          <Box
            sx={{ display: "flex", gap: 2, ml: "auto", alignItems: "center" }}
          >
            <Tooltip title="Changer le thème">
              <IconButton
                onClick={handleThemeMenuClick}
                color="inherit"
                aria-label="toggle theme"
                aria-controls={themeMenuOpen ? "theme-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={themeMenuOpen ? "true" : undefined}
                sx={{
                  color: theme.palette.mode === "dark" ? "white" : "inherit",
                }}
              >
                {getThemeIcon()}
              </IconButton>
            </Tooltip>
            <Menu
              id="theme-menu"
              anchorEl={themeMenuAnchorEl}
              open={themeMenuOpen}
              onClose={handleThemeMenuClose}
              MenuListProps={{
                "aria-labelledby": "theme-button",
              }}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              sx={{
                "& .MuiPaper-root": {
                  borderRadius: "5px", // or any value you want
                },
              }}
            >
              <MenuItem onClick={() => handleThemeChange("light")}>
                <WbSunnyOutlined style={{ marginRight: 8 }} /> Clair
              </MenuItem>
              <MenuItem onClick={() => handleThemeChange("dark")}>
                <BedtimeOutlined style={{ marginRight: 8 }} /> Sombre
              </MenuItem>
              <MenuItem onClick={() => handleThemeChange("system")}>
                <SettingsBrightness style={{ marginRight: 8 }} /> Système
              </MenuItem>
            </Menu>

            {isLoggedIn ? (
              <>
                <Tooltip title="Compte utilisateur">
                  <IconButton
                    onClick={handleUserMenuClick}
                    sx={{
                      ml: 1,
                    }}
                  >
                    <Avatar
                      sx={{
                        bgcolor: theme.palette.primary.main,
                        color: "white",
                        width: 40,
                        height: 40,
                        transition: "transform 0.2s",
                        "&:hover": {
                          transform: "scale(1.1)",
                        },
                      }}
                    >
                      {getUserInitials()}
                    </Avatar>
                  </IconButton>
                </Tooltip>
                <Menu
                  id="user-menu"
                  anchorEl={userMenuAnchorEl}
                  open={userMenuOpen}
                  onClose={handleUserMenuClose}
                  MenuListProps={{
                    "aria-labelledby": "user-button",
                  }}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                >
                  {auth.user.role !== 2 && (
                    <MenuItem
                      onClick={handleUserMenuClose}
                      component={RouterLink}
                      href="/dashboard"
                    >
                      <AccountCircleIcon style={{ marginRight: 8 }} /> Mon
                      profil
                    </MenuItem>
                  )}
                  <MenuItem onClick={handleLogout}>
                    <LogoutIcon style={{ marginRight: 8 }} /> Se déconnecter
                  </MenuItem>
                </Menu>
              </>
            ) : (
              <>
                <Button
                  component={RouterLink}
                  onClick={() => navigate("/login")}
                  href="/login"
                  color="primary"
                  variant="outlined"
                  sx={{
                    borderRadius: 20,
                    padding: "12px 16px",
                    fontSize: 14,
                    letterSpacing: "-1.1%",
                    borderColor: theme.palette.primary.main,
                    color: theme.palette.primary.main,
                    fontFamily: "'Inter', serif",
                    "&:hover": {
                      borderColor: theme.palette.primary.dark,
                      backgroundColor: "rgba(0, 0, 0, 0.04)",
                    },
                  }}
                >
                  Se connecter
                </Button>
                <Button
                  component={RouterLink}
                  onClick={() => navigate("/register")}
                  href="/register"
                  color="primary"
                  variant="contained"
                  sx={{
                    borderRadius: 40,
                    padding: "12px 16px",
                    color: "white",
                    fontSize: 14,
                    letterSpacing: "-1.1%",
                    fontFamily: "'Inter', serif",
                    "&:hover": {
                      backgroundColor: theme.palette.primary.dark,
                    },
                  }}
                >
                  Créer un compte
                </Button>
              </>
            )}
          </Box>
        )}

        {isMobile && (
          <>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleDrawerOpen}
              sx={{
                color: theme.palette.mode === "dark" ? "white" : "black",
                transition: "transform 0.3s",
                "&:hover": { transform: "scale(1.2)" },
              }}
            >
              <MenuIcon fontSize="large" />
            </IconButton>
            <Drawer
              anchor="right"
              open={drawerOpen}
              onClose={handleDrawerClose}
              sx={{
                "& .MuiDrawer-paper": {
                  width: 300,
                  boxSizing: "border-box",
                  borderRadius: "8px 0 0 8px",
                  boxShadow: 4,
                },
              }}
            >
              <Box
                sx={{
                  p: 3,
                  bgcolor: theme.palette.background.default,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                  Menu
                </Typography>
                <IconButton onClick={handleDrawerClose} size="small">
                  ✕
                </IconButton>
              </Box>

              {isLoggedIn && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    px: 3,
                    pb: 2,
                    pt: 1,
                  }}
                >
                  <Avatar
                    sx={{
                      bgcolor: theme.palette.primary.main,
                      color: "white",
                      width: 40,
                      height: 40,
                      mr: 2,
                    }}
                  >
                    {getUserInitials()}
                  </Avatar>
                  <Typography variant="subtitle1">
                    {currentUser && currentUser.name
                      ? currentUser.fname + " " + currentUser.name
                      : "Utilisateur"}
                  </Typography>
                </Box>
              )}

              <List sx={{ px: 2 }}>
                {navLinks.map((link) => (
                  <ListItem key={link.href} disablePadding sx={{ mb: 1 }}>
                    <ListItemButton
                      component={RouterLink}
                      href={link.href}
                      onClick={handleDrawerClose}
                      sx={{
                        py: 1.5,
                        px: 3,
                        borderRadius: 2,
                        transition: "all 0.3s",
                        "&:hover": {
                          bgcolor: theme.palette.action.hover,
                          transform: "translateX(5px)",
                        },
                      }}
                    >
                      <ListItemIcon
                        sx={{ minWidth: 40, color: theme.palette.primary.main }}
                      >
                        {link.icon}
                      </ListItemIcon>
                      <ListItemText primary={link.label} />
                    </ListItemButton>
                  </ListItem>
                ))}

                {/* Theme selector in mobile drawer */}
                <ListItem disablePadding sx={{ mb: 1 }}>
                  <ListItemButton
                    onClick={handleMobileThemeMenuToggle}
                    sx={{
                      py: 1.5,
                      px: 3,
                      borderRadius: 2,
                      transition: "all 0.3s",
                      "&:hover": {
                        bgcolor: theme.palette.action.hover,
                      },
                    }}
                  >
                    <ListItemIcon
                      sx={{ minWidth: 40, color: theme.palette.primary.main }}
                    >
                      {getThemeIcon()}
                    </ListItemIcon>
                    <ListItemText primary={getThemeLabel()} />
                  </ListItemButton>
                </ListItem>

                <Collapse in={mobileThemeMenuOpen} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <ListItemButton
                      onClick={() => handleThemeChange("light")}
                      sx={{
                        pl: 8,
                        py: 1,
                        borderRadius: 2,
                        transition: "all 0.3s",
                        "&:hover": {
                          bgcolor: theme.palette.action.hover,
                        },
                      }}
                    >
                      <ListItemIcon
                        sx={{ minWidth: 40, color: theme.palette.primary.main }}
                      >
                        <WbSunnyOutlined fontSize="small" />
                      </ListItemIcon>
                      <ListItemText primary="Thème clair" />
                    </ListItemButton>
                    <ListItemButton
                      onClick={() => handleThemeChange("dark")}
                      sx={{
                        pl: 8,
                        py: 1,
                        borderRadius: 2,
                        transition: "all 0.3s",
                        "&:hover": {
                          bgcolor: theme.palette.action.hover,
                        },
                      }}
                    >
                      <ListItemIcon
                        sx={{ minWidth: 40, color: theme.palette.primary.main }}
                      >
                        <BedtimeOutlined fontSize="small" />
                      </ListItemIcon>
                      <ListItemText primary="Thème sombre" />
                    </ListItemButton>
                    <ListItemButton
                      onClick={() => handleThemeChange("system")}
                      sx={{
                        pl: 8,
                        py: 1,
                        borderRadius: 2,
                        transition: "all 0.3s",
                        "&:hover": {
                          bgcolor: theme.palette.action.hover,
                        },
                      }}
                    >
                      <ListItemIcon
                        sx={{ minWidth: 40, color: theme.palette.primary.main }}
                      >
                        <SettingsBrightness fontSize="small" />
                      </ListItemIcon>
                      <ListItemText primary="Thème système" />
                    </ListItemButton>
                  </List>
                </Collapse>

                {isLoggedIn && currentUser && currentUser.role !== 2 && (
                  <>
                    <ListItem disablePadding sx={{ mb: 1 }}>
                      <ListItemButton
                        component={RouterLink}
                        href="/dashboard"
                        onClick={handleDrawerClose}
                        sx={{
                          py: 1.5,
                          px: 3,
                          borderRadius: 2,
                          transition: "all 0.3s",
                          "&:hover": {
                            bgcolor: theme.palette.action.hover,
                            transform: "translateX(5px)",
                          },
                        }}
                      >
                        <ListItemIcon
                          sx={{
                            minWidth: 40,
                            color: theme.palette.primary.main,
                          }}
                        >
                          <AccountCircleIcon />
                        </ListItemIcon>
                        <ListItemText primary="Mon profil" />
                      </ListItemButton>
                    </ListItem>
                  </>
                )}
                {isLoggedIn && (
                  <>
                    <ListItem disablePadding>
                      <ListItemButton
                        onClick={() => {
                          handleLogout();
                          handleDrawerClose();
                        }}
                        sx={{
                          py: 1.5,
                          px: 3,
                          borderRadius: 2,
                          transition: "all 0.3s",
                          "&:hover": {
                            bgcolor: theme.palette.action.hover,
                            transform: "translateX(5px)",
                          },
                        }}
                      >
                        <ListItemIcon
                          sx={{
                            minWidth: 40,
                            color: theme.palette.primary.main,
                          }}
                        >
                          <LogoutIcon />
                        </ListItemIcon>
                        <ListItemText primary="Se déconnecter" />
                      </ListItemButton>
                    </ListItem>
                  </>
                )}

                {!isLoggedIn && (
                  <>
                    <ListItem disablePadding sx={{ mb: 1 }}>
                      <ListItemButton
                        component={RouterLink}
                        href="/login"
                        onClick={handleDrawerClose}
                        sx={{
                          py: 1.5,
                          px: 3,
                          borderRadius: 2,
                          transition: "all 0.3s",
                          "&:hover": {
                            bgcolor: theme.palette.action.hover,
                            transform: "translateX(5px)",
                          },
                        }}
                      >
                        <ListItemIcon
                          sx={{
                            minWidth: 40,
                            color: theme.palette.primary.main,
                          }}
                        >
                          <LoginIcon />
                        </ListItemIcon>
                        <ListItemText primary="Se connecter" />
                      </ListItemButton>
                    </ListItem>
                    <ListItem disablePadding>
                      <ListItemButton
                        component={RouterLink}
                        href="/register"
                        onClick={() => {
                          // navigate('/register');
                          handleDrawerClose();
                        }}
                        sx={{
                          py: 1.5,
                          px: 3,
                          borderRadius: 2,
                          bgcolor: theme.palette.primary.main,
                          color: "white",
                          transition: "all 0.3s",
                          "&:hover": {
                            bgcolor: theme.palette.primary.dark,
                            transform: "translateX(5px)",
                          },
                        }}
                      >
                        <ListItemIcon sx={{ minWidth: 40, color: "white" }}>
                          <PersonAddIcon />
                        </ListItemIcon>
                        <ListItemText primary="S'inscrire" />
                      </ListItemButton>
                    </ListItem>
                  </>
                )}
              </List>
            </Drawer>
          </>
        )}
      </Toolbar>
      {/* <Divider /> */}
    </AppBar>
  );
}